import _store from "store2";
import {getEmailGroupFileList, getEmailGroupFileListPage} from "@/api/sidebar";
import {ElMessage} from "element-plus";
import {nextTick} from "vue";
import {sortFolders} from "@/utils/util";

const sidebar = {
    namespaced: true,
    state: {
        fileList: [],
        targetFileList: [],
        isRouterAlive: true,
        pageSetting: {
            pageNo: 1,
            pageSize: 20,
            total: 0,
        },

    }, getters: {
        hasMoreData(state) {
            return state.targetFileList.length <= state.pageSetting.total
        }

    }, mutations: {
        async reload(state) {
            state.isRouterAlive = false;
            await nextTick(() => {
                state.isRouterAlive = true;
            })
        },
        setTargetFileList(state, payload) {
            state.targetFileList = payload
        },
        setPageSetting(state, payload) {
            const {type, value} = payload
            state.pageSetting[type] = value
        }
    },
    actions: {
        async getEmailGroupFileListApis({state, commit}, payload) {
            // 分页查询
            const {isUpdateFileList, teamId, userId} = payload
            let res = await getEmailGroupFileListPage({
                teamId,
                userId,
                pageNo: state.pageSetting.pageNo,
                pageSize: state.pageSetting.pageSize
            })
            if (res.code !== 200) {
                ElMessage.error(res.message)
                return
            }
            console.log('rdddddes', isUpdateFileList, res.result.records)
            state.pageSetting.pageNo = res.result.current;
            state.pageSetting.pageSize = res.result.size;
            state.pageSetting.total = res.result.total;
            if (isUpdateFileList) {
                state.targetFileList = [...state.targetFileList, ...res.result.records];
            } else {
                state.targetFileList = res.result.records;
            }
        },
        async getEmailGroupFileAllList({state, commit}, payload) {
            const {isUpdateFileList, teamId, userId} = payload
            let res = await getEmailGroupFileList({
                teamId,
                userId,
            })
            if (res.code !== 200) {
                ElMessage.error(res.message)
                return
            }
            const result = sortFolders(res.result)
            state.fileList = result
        }
    },
};

export default sidebar;
